import React from 'react'
import './CardOne.css'

function CardOne() {
    return (
        <div className="cardOne">
          <h1>There's a better way<br/>
          to grow.</h1>
          <p>
          Marketing, sales, and service software that helps<br/> 
          your business grow without compromise. Because<br/> 
          “good for the business” should also mean “good for<br/> 
          the customer.”
          </p>
          <button className="card_button">Get HubSpot free</button>
          <p>
          Get started with FREE tools, and<br/> upgrade as you grow.
          </p>
        </div>
    )
}

export default CardOne
